import React from "react";
import "./content-header.css";

export default function ContentHeaderTemplate({ block }) {
  const {
    title,
    subtitle,
    text,
    backgroundUrl,
    elementClass,
    textClass,
  } = block;

  const rootClassName = [
    "content-header",
    elementClass,
  ]
    .filter(Boolean)
    .join(" ");

  const textWrapperClassName = [
    "cms-block-text",
    "text-center",
    textClass,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName}>
      <div className="title-wrapper position-relative">
        {backgroundUrl && (
          <div className="background">
            <img src={backgroundUrl} alt="" />
            <div className="overlay"></div>
          </div>
        )}
        <div className="container position-relative">
          <div className="position-relative">
            {title && (
              <div className="cms-block-title">
                <h1>
                  <span>{title}</span>
                </h1>
              </div>
            )}

            {subtitle && (
              <div
                className="cms-block-subtitle text-center"
                dangerouslySetInnerHTML={{ __html: subtitle }}
              />
            )}
          </div>
        </div>
      </div>

      {/* Contenu éditorial optionnel */}
      {text && (
        <div className="content-header-text container">
          <div
            className={textWrapperClassName}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </div>
      )}
    </div>
  );
}
